<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  &nbsp;
  <button
    mat-icon-button
    (click)="handleEditComplete(false)"
    title="Cancel"
    class="close-button"
    tabindex="-1"
    >
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.scoringCategory) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Scoring Category Description</mat-label>
          <textarea matInput [(ngModel)]="data.scoringCategory.description" [disabled]="!data.canEdit"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field">
          <mat-label>Display Order</mat-label>
          <input matInput [(ngModel)]="data.scoringCategory.displayOrder" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      @if (data.displayScoringModelbyMoveNumber) {
        <div>
          <mat-form-field class="description-field">
            <mat-label>First Move to Display</mat-label>
            <input matInput [(ngModel)]="data.scoringCategory.moveNumberFirstDisplay" [disabled]="!data.canEdit" />
          </mat-form-field>
        </div>
      }
    </div>
    <div class="add-margin">
      @if (data.displayScoringModelbyMoveNumber) {
        <div>
          <mat-form-field class="description-field">
            <mat-label>Last Move to Display</mat-label>
            <input matInput [(ngModel)]="data.scoringCategory.moveNumberLastDisplay" [disabled]="!data.canEdit" />
          </mat-form-field>
        </div>
      }
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Calculation Equation</mat-label>
          <textarea matInput [(ngModel)]="data.scoringCategory.calculationEquation" [disabled]="!data.canEdit"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field">
          <mat-label>Calculation Weight</mat-label>
          <input matInput [(ngModel)]="data.scoringCategory.scoringWeight" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Scoring Option Selection Type</mat-label>
          <mat-select placeholder="Select a Scoring Option Selection Type" [(ngModel)]="data.scoringCategory.scoringOptionSelection" [disabled]="!data.canEdit">
            @for (item of data.scoringOptionSelections; track item) {
              <mat-option [value]="item">
                {{ item }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox [(ngModel)]="data.scoringCategory.isModifierRequired" [disabled]="!data.canEdit">Modifier Selection Required</mat-checkbox>
      </div>
    </div>
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree() || !data.canEdit" style="margin-left: 40px;">Save</button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
      </div>
    </div>
  </div>
}
